import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { set } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import useStyles from "./style";
import Footer from "../../../components/molecules/LoginNav/footer";
import {
  AppBar,
  Container,
  Grid,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { date } from "../../../utils/dateTime";
import MaterialTable from "material-table";
import TokorameIcon from "../../../assets/logo-tokorame.svg";
import tableIcons from "../../../components/tableicon/table-icons";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";

function SalesReport() {
  const { profil } = useData();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [startDate, handleStartDateChange] = useState(
    set(new Date(), {
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    })
  );

  const [endDate, handleEndDateChange] = useState(
    set(new Date(), {
      hours: 47,
      minutes: 59,
      seconds: 59,
      milliseconds: 999,
    })
  );

  const [table, setTable] = useState({
    columns: [
      {
        title: "Paid at",
        field: "paid_at",
        render: (rowData) => (
          <>
            {rowData && rowData.created_at !== null ? (
              <span>{date(rowData.created_at)}</span>
            ) : (
              <span>-</span>
            )}
          </>
        ),
      },
      {
        title: "Kode Order",
        field: "kode_order",
      },
      {
        title: "Nama Seller",
        field: "nama_seller",
      },
      { title: "Level", field: "level" },
      { title: "Status", field: "status" },
      { title: "Total Tagihan", field: "total_tagihan" },
      { title: "Komisi", field: "komisi" },
    ],
    data: [],
  });

  const getData = async () => {
    setLoading(true);
    try {
      const func = firefunctions.httpsCallable("getDataKomisi");
      const data = {
        user_id: profil?.id,
        start_date: startDate.toISOString().substring(0, 10),
        end_date: endDate.toISOString().substring(0, 10),
      };
      // console.log("ini pas milih", data);
      const res = await func(data);
      setData(res?.data ?? []);
      setTable((table) => {
        const obj = {
          ...table,
          data: res?.data
            ? res?.data.map((doc) => {
                return {
                  ...doc,
                };
              })
            : [],
        };
        return obj;
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [startDate, endDate]);

  return (
    <Grid container xs={12}>
      <Paper className={classes.paperWrap}>
        <AppBar position="static">
          <Toolbar>
            <div className={classes.wrapHeader}>
              <div className={classes.wrapIcon}>
                <img src={TokorameIcon} alt="tokorame" />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div className={classes.pageWrapWrap}>
          <div className={classes.content}>
            <div className={classes.root}>
              <Container>
                <ExcelFile
                  filename="Data Sales Report"
                  element={
                    data.length > 0 ? (
                      <div
                        style={{
                          // marginTop: "20px",
                          marginBottom: "12px",
                          // marginLeft: 24,
                          border: "1px solid #5675D3",
                          // marginRight: 24,
                          borderRadius: 4,
                          backgroundColor: "#DEE4F7",
                          padding: "12px",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <div style={{ marginRight: 8, alignSelf: "center" }}>
                          <GetAppIcon color="primary" />
                        </div>
                        <div style={{ marginTop: "2.5px" }}>
                          <Typography
                            color="primary"
                            style={{
                              fontSize: 13,
                              color: "#5675D3",
                            }}
                          >
                            Silahkan Klik Disini Untuk Mendownload Data Lebih
                            Lengkap.
                          </Typography>
                        </div>
                      </div>
                    ) : null
                  }
                >
                  <ExcelSheet data={data} name="Data Sales Report">
                    <ExcelColumn
                      label="Created at"
                      value={(col) => date(col.created_at)}
                    />
                    <ExcelColumn
                      label="Paid at"
                      value={(col) => date(col.paid_at)}
                    />
                    <ExcelColumn label="Kode Order" value="kode_order" />
                    <ExcelColumn
                      label="Lokasi Order"
                      value="order_info_location"
                    />
                    <ExcelColumn label="Nama Seller" value="nama_seller" />
                    <ExcelColumn label="Level" value="level" />
                    <ExcelColumn label="Subdomain" value="subdomain" />
                    <ExcelColumn label="Status" value="status" />
                    <ExcelColumn
                      label="Status Pengiriman"
                      value="status_pengiriman"
                    />
                    <ExcelColumn
                      label="Status Pembayaran"
                      value="status_pembayaran"
                    />
                    <ExcelColumn
                      label="Total Biaya Pengiriman"
                      value="total_biaya_pengiriman"
                    />
                    <ExcelColumn
                      label="Total Pembayaran"
                      value="total_pembayaran"
                    />
                    <ExcelColumn label="Total Tagihan" value="total_tagihan" />
                    <ExcelColumn label="Total Gross" value="gross" />
                    <ExcelColumn label="Total Promo" value="total_promo" />
                    <ExcelColumn label="Komisi" value="komisi" />
                  </ExcelSheet>
                </ExcelFile>
                <div style={{ marginBottom: "12px" }}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      style={{
                        marginRight: "10px",
                      }}
                      disableToolbar
                      variant="inline"
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <MaterialTable
                  columns={table.columns}
                  data={table.data}
                  title="Data Sales Report"
                  isLoading={loading}
                  icons={tableIcons}
                  options={{
                    pageSize: 5,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    headerStyle: {
                      fontWeight: "bold",
                    },
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loading ? null : "Tidak Ada Data",
                    },
                    toolbar: {
                      searchTooltip: "Cari",
                      searchPlaceholder: "Cari Data",
                    },
                    header: {
                      actions: "Actions",
                    },
                    pagination: {
                      labelRowsSelect: "Baris",
                      labelDisplayedRows: " {from}-{to} Dari {count} Baris",
                      firstTooltip: "Halaman Pertama",
                      previousTooltip: "Halaman Sebelumnya",
                      nextTooltip: "Halaman Selanjutnya",
                      lastTooltip: "Halaman Terakhir",
                    },
                  }}
                />
              </Container>
            </div>
          </div>
        </div>
        <Footer />
      </Paper>
    </Grid>
  );
}

export default SalesReport;
